import jsPDF from "jspdf";
import { store } from "../../index";

import { imgData } from "./letterhead";
import { tnmformatnumber, invformatnumber } from "../../services/tnminvnumbers";
const pdfdownload = invoice => {
  var doc = new jsPDF();
  var index = 0;
  var arrayLength = invoice.wodlist.length;
  var chunk_size = 10;
  var sheetNum = 1;
  var sheetcount = Math.ceil(arrayLength / chunk_size);
  var employees = store.getState().employees.employees;
  // You'll need to make your image into a Data URL
  // Use http://dataurl.net/#dataurlmaker
  var doc = new jsPDF();

  for (index = 0; index < arrayLength; index += chunk_size) {
    let WodChunk = invoice.wodlist.slice(index, index + chunk_size);
    // Do something if you want with the group
    if (sheetNum > 1) {
      doc.addPage();
    }
    //Header Image
    doc.addImage(imgData, "JPEG", 15, 10, 113, 22);

    doc.setFontSize(18);
    doc.setFont("helvetica");
    doc.setFontType("bold");
    doc.text(160, 20, "INVOICE");

    //HR
    doc.setLineWidth(0.5);
    doc.line(15, 37, 200, 37);

    //Header
    doc.setFontSize(12);
    doc.setFont("helvetica");
    doc.setFontType("bold");
    doc.text(20, 47, "SOLD TO:");
    doc.setFontType("normal");
    doc.text(20, 52, invoice.billing.companyname1);
    doc.text(20, 57, invoice.billing.street1);
    doc.text(20, 62, invoice.billing.city + " " + invoice.billing.state);
    doc.text(20, 67, "ATTN: " + invoice.rootwod.contactName);

    doc.setFontSize(12);
    doc.setFont("helvetica");
    doc.setFontType("bold");
    doc.text(20, 75, "REMIT TO:");
    doc.setFontType("normal");
    doc.text(20, 80, "8390 Currency Dr.");
    doc.text(20, 85, "Riviera Beach Fl. 33404 Unit 4");
    doc.text(20, 90, "Phone: 561-844-8886");
    doc.text(20, 95, "Fax: 561-842-3929");

    doc.setFontType("bold");
    doc.text(141, 52, "Number:");
    doc.setFontType("normal");
    doc.text(160, 52, invformatnumber(invoice));

    doc.setFontType("bold");
    doc.text(148, 57, "Date:");
    doc.setFontType("normal");
    doc.text(160, 57, invoice.createdate);

    doc.setFontType("bold");
    doc.text(125, 62, "Purchase Order:");
    doc.setFontType("normal");
    doc.text(160, 62, invoice.rootwod.poNbr);

    doc.setFontType("bold");
    doc.text(136, 67, "Line Item#:");
    doc.setFontType("normal");
    doc.text(
      160,
      67,
      invoice.rootwod.poItemNbr ? invoice.rootwod.poItemNbr.toString() : ""
    );

    doc.setFontType("bold");
    doc.text(145, 72, "SOW#:");
    doc.setFontType("normal");
    doc.text(160, 72, invoice.rootwod.acctNbr ? invoice.rootwod.acctNbr : "");

    doc.setFontType("bold");
    doc.text(146, 77, "EDF#:");
    doc.setFontType("normal");
    doc.text(160, 77, invoice.rootwod.workOrderNbr);

    doc.setFontType("bold");
    doc.text(126, 82, "T&M's Included:");
    doc.setFontType("normal");
    if (invoice.tmlist.length > 8) {
      doc.text(160, 82, "Various");
    } else {
      invoice.tmlist.map((tm, ind) => {
        console.log(ind);

        doc.text(160, 82 + ind * 5, tnmformatnumber(tm));
      });
    }

    doc.setFontType("bold");
    doc.text(20, 105, "Period:");
    doc.setFontType("normal");
    doc.text(40, 105, invoice.periodbegindate + " TO " + invoice.periodenddate);

    doc.setFontType("bold");
    doc.text(20, 110, "Task Description:");
    doc.setFontType("normal");
    doc.text(20, 115, invoice.rootwod.description);

    //Time Entrys
    //+6 pt in Y directopm per entry
    doc.setFontType("normal");
    var lastrow;
    //Time Example
    var row = 134;
    doc.setFontType("bold");
    doc.text(15, 125, "Work \nOrder #");
    doc.text(40, 125, "Task Description");
    doc.text(125, 125, "Current");
    doc.text(152, 125, "Prev.");
    doc.text(177, 125, "Sub Total");
    doc.setFontType("normal");

    WodChunk.map((wod, index) => {
      if (index === WodChunk.length - 1) {
        lastrow = 130 + index * 6;
        console.log(lastrow);
      }
      //+6 pt in Y directopm per entry
      doc.setFontType("normal");
      // doc.text(160, row - 53, wod.workOrderNbr);
      //Charge Example
      doc.text(15, row + index * 6, wod.workOrderNbr);
      doc.text(37, row + index * 6, wod.description.slice(0, 33));
      doc.text(125, row + index * 6, "$" + wod.currenttotal);
      doc.text(152, row + index * 6, "$" + wod.prevtotal);
      doc.text(177, row + index * 6, "$" + wod.subtotal);
    });

    if (sheetNum === sheetcount) {
      //HR

      //Subtotal Example

      lastrow += 11;
      doc.setLineWidth(0.5);
      doc.line(15, lastrow - 5, 200, lastrow - 5);
      doc.setFontType("bold");
      doc.text(15, lastrow, "Totals:");
      doc.text(125, lastrow, "$" + invoice.currentTotal);
      doc.text(152, lastrow, "$" + invoice.prevTotal);
      doc.text(177, lastrow, "$" + invoice.SubTotal);
      doc.setLineWidth(0.5);
      doc.line(15, lastrow + 3, 200, lastrow + 3);
      let newbudget =
        parseFloat(invoice.rootwod.budget) +
        parseFloat(invoice.rootwod.supplements);
      doc.setFontType("bold");
      doc.text(155, lastrow + 8, "Budget:");
      doc.setFontType("normal");
      doc.text(177, lastrow + 8, "$" + newbudget);

      doc.setFontType("bold");
      doc.text(130, lastrow + 13, "Previous Years Adj.:"); // #WE_Date
      doc.setFontType("normal");
      doc.setTextColor(255, 0, 0);
      doc.text(177, lastrow + 13, "$" + invoice.rootwod.prevYearAdj);

      doc.setTextColor(0, 0, 0);
      doc.setFontType("bold");
      doc.text(148, lastrow + 18, "Remaining:"); // #WE_Date
      doc.setFontType("normal");
      //if negitive doc.setTextColor(255, 0, 0)
      doc.text(177, lastrow + 18, "$" + invoice.Remaining);
      //Reset Color
      doc.setTextColor(0, 0, 0);
      lastrow += 18;
      //HR

      doc.setLineWidth(0.5);
      doc.line(15, lastrow + 10, 200, lastrow + 10);

      //Subtotal Example
      doc.setFontType("bold");
      doc.text(
        60,
        lastrow + 16,
        "TOTAL - PAY THIS AMOUNT ===>$" + invoice.currentTotal + "<==="
      );

      //HR
      doc.setLineWidth(0.5);
      doc.line(15, lastrow + 19, 200, lastrow + 19);

      //Footer

      doc.text(110, 250, "Approved:");
      doc.line(131, 250, 200, 250);

      doc.text(142, 255, "Authorized Representative");
      doc.save(invformatnumber(invoice) + ".pdf");
    }
    doc.text(100, 266, "(Sheet " + sheetNum + " of " + sheetcount + ")");

    sheetNum += 1;
  }
};

export default pdfdownload;



// WEBPACK FOOTER //
// ./src/components/pdf/invPDFDownload.js